// extracted by mini-css-extract-plugin
module.exports = {"subscriptionFaq":"PaymentsFAQ__subscriptionFaq","faqColumns":"PaymentsFAQ__faqColumns"};